import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback, useMemo } from 'react';
import { map, uniqueId, isArray, isString } from 'lodash-es';
import { SelectField } from './select-field';
export function FormField({ value, label, type, options, placeholder, required, minLength, maxLength, onChange, showValues, className, rows, checked = false, }) {
    const fieldId = useMemo(() => uniqueId('form_field'), []);
    const handleChange = useCallback((event) => {
        onChange(event.target.value);
    }, [onChange]);
    const finalOptions = isArray(options) ?
        map(options, option => isString(option) ? { value: option, label: option } : option) :
        [];
    if (type === 'text') {
        return (_jsx("div", { className: className || 'form-field', children: _jsx("input", { id: fieldId, type: "text", value: value, placeholder: placeholder, minLength: minLength, maxLength: maxLength, onChange: handleChange, required: required }) }));
    }
    if (type === 'number') {
        return (_jsx("div", { className: className || 'form-field', children: _jsx("input", { id: fieldId, type: "number", value: value, placeholder: placeholder, minLength: minLength, maxLength: maxLength, onChange: handleChange, required: required }) }));
    }
    if (type === 'email') {
        return (_jsx("div", { className: className || 'form-field', children: _jsx("input", { id: fieldId, type: "email", value: value, minLength: minLength, maxLength: maxLength, onChange: handleChange, required: required, placeholder: placeholder }) }));
    }
    if (type === 'textarea') {
        return (_jsx("div", { className: className || 'form-field', children: _jsx("textarea", { id: fieldId, value: value, minLength: minLength, maxLength: maxLength, onChange: handleChange, required: required, rows: rows, placeholder: label }) }));
    }
    if (type === 'select') {
        return (_jsx("div", { className: className || 'form-field', children: _jsx(SelectField, { id: fieldId, value: value, placeholder: placeholder, options: finalOptions, onChange: onChange, showValues: showValues }) }));
    }
    if (type === 'multi-select') {
        return (_jsx("div", { className: className || 'form-field', children: _jsx(SelectField, { id: fieldId, value: value, placeholder: placeholder, options: finalOptions, onChange: onChange, multiple: true, showValues: showValues }) }));
    }
    if (type === 'checkbox') {
        return (_jsxs("div", { className: className || 'form-field', children: [_jsx("input", { id: fieldId, name: fieldId, type: "checkbox", checked: checked, onChange: handleChange, required: required, value: checked ? "off" : "on" }), label ? _jsx("label", { className: "checkbox-label", htmlFor: fieldId, children: label }) : null] }));
    }
    return null;
}
